export const PAGE_GRID_RATIO = {
  leftMargin: {
    xs: 0.25,
    xl: 0.5,
  },
  mainContent: {
    xs: 8.5,
    xl: 8.5,
  },
  middleMargin: {
    xs: 0.25,
    xl: 0.25,
  },
  rightSidebar: {
    xs: 2.75,
    xl: 2.25,
  },
  rightMargin: {
    xs: 0.25,
    xl: 0.5,
  },
};
